<template>
    <v-dialog width="800px" v-model="show" lazy>
        <v-card>
            <v-stepper v-model="el">
                <v-stepper-header>
                    <v-stepper-step :complete="el > formStep" :step="formStep" @click="el=1">
                        {{$t(formProperties.title)}}
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="el > feeStep" :step="feeStep" @click="el=2">
                        {{$t("lang.files.feeCalculate")}}
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="el > documentStep" :step="documentStep" @click="el=3">
                        {{$t("lang.files.document")}}
                    </v-stepper-step>
                    <v-divider></v-divider>

                    <v-stepper-step :step="mailStep" @click="el=mailStep">{{$t("lang.files.email")}}</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content :step="formStep" v-if="formStep>0">
                        <v-form id="createForm">
                            <form id="formProcess">
                                <v-tabs color="cyan" dark v-model="tabs"
                                        v-if="formProperties['tabs'] != null && formProperties['tabs'].length >0"
                                        slider-color="yellow">
                                    <v-tab v-for="tab in formProperties['tabs']" :key="tab.key">
                                        {{ tab.name }}
                                    </v-tab>
                                    <v-tabs-items style="padding: 10px">
                                        <v-tab-item v-for="tab in formProperties['tabs']" :key="tab.key">
                                            <div v-for="item in lstModel">
                                                <div v-if="item.properties['container'] == tab.name">
                                                    <v-text-field v-if="item.type=='Hidden'" style="display:none"
                                                                  v-model.trim="values[item.properties['name']]"
                                                                  v-bind="item.properties"></v-text-field>
                                                    <c-textbox v-if="item.type=='Textbox'"
                                                               v-model.trim="values[item.properties['name']]"
                                                               v-bind="item.properties" ref="input"></c-textbox>
                                                    <i-datepicker v-if="item.type=='DateField'"
                                                                  v-model="values[item.properties['name']]"
                                                                  v-bind="item.properties" ref="input"/>
                                                    <v-textarea v-if="item.type=='Textarea'"
                                                                v-model.trim="values[item.properties['name']]"
                                                                v-bind="item.properties" ref="input"></v-textarea>
                                                    <i-selectbox v-if="item.type=='SelectBox'"
                                                                 v-model="values[item.properties['name']]"
                                                                 v-bind="item.properties" @change="showValues"
                                                                 :variable="values" ref="input"></i-selectbox>

                                                    <v-radio-group v-if="item.type=='Radio'"
                                                                   v-model="values[item.properties['name']]"
                                                                   v-bind="item.properties" ref="input">
                                                        <v-radio v-for="option in item.properties['items']"
                                                                 :label="option"
                                                                 :value="option"
                                                                 :key="option"></v-radio>
                                                    </v-radio-group>
                                                    <v-checkbox v-if="item.type=='Checkbox'"
                                                                v-model="values[item.properties['name']]"
                                                                v-bind="item.properties"></v-checkbox>

                                                    <i-upload v-if="item.type=='Upload'"
                                                              v-model="values[item.properties['name']]"
                                                              v-bind="item.properties" ref="input"
                                                              :variable="values"></i-upload>
                                                    <i-data-table v-if="item.type=='DataTable'"
                                                                  v-model="values[item.properties['name']]"
                                                                  :variable="values"
                                                                  v-bind="item.properties" ref="input"></i-data-table>
                                                    <i-entity-table v-if="item.type=='Entity'"
                                                                    v-model="values[item.properties['name']]"
                                                                    :variable="values"
                                                                    v-bind="item.properties"></i-entity-table>
                                                    <component v-if="item.type=='Component'"
                                                               v-model="values[item.properties['name']]"
                                                               :variable="values" :is="item.component"
                                                               v-bind="item.properties"></component>
                                                </div>
                                            </div>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-tabs>
                                <div v-else style="padding: 10px">
                                    <div v-for="item in lstModel">
                                        <v-text-field v-if="item.type=='Hidden'" style="display:none"
                                                      v-model.trim="values[item.properties['name']]"
                                                      v-bind="item.properties"></v-text-field>
                                        <c-textbox v-if="item.type=='Textbox'"
                                                   v-model.trim="values[item.properties['name']]"
                                                   v-bind="item.properties" ref="input"></c-textbox>
                                        <i-datepicker v-if="item.type=='DateField'"
                                                      v-model="values[item.properties['name']]"
                                                      v-bind="item.properties" ref="input"/>
                                        <v-textarea v-if="item.type=='Textarea'"
                                                    v-model.trim="values[item.properties['name']]"
                                                    v-bind="item.properties" ref="input"></v-textarea>
                                        <i-selectbox v-if="item.type=='SelectBox'"
                                                     v-model="values[item.properties['name']]"
                                                     v-bind="item.properties" @change="showValues"
                                                     :variable="values" ref="input"></i-selectbox>
                                        <v-radio-group v-if="item.type=='Radio'"
                                                       v-model="values[item.properties['name']]"
                                                       v-bind="item.properties" ref="input">
                                            <v-radio v-for="option in item.properties['items']" :label="option"
                                                     :value="option"
                                                     :key="option"></v-radio>
                                        </v-radio-group>
                                        <v-checkbox v-if="item.type=='Checkbox'"
                                                    v-model="values[item.properties['name']]"
                                                    v-bind="item.properties"></v-checkbox>

                                        <i-upload v-if="item.type=='Upload'" v-model="values[item.properties['name']]"
                                                  v-bind="item.properties" ref="input" :variable="values"></i-upload>
                                        <i-data-table v-if="item.type=='DataTable'"
                                                      v-model="values[item.properties['name']]"
                                                      :variable="values"
                                                      v-bind="item.properties" ref="input"></i-data-table>
                                        <i-entity-table v-if="item.type=='Entity'"
                                                        v-model="values[item.properties['name']]"
                                                        :variable="values"
                                                        v-bind="item.properties"></i-entity-table>
                                        <component v-if="item.type=='Component'"
                                                   v-model="values[item.properties['name']]"
                                                   :variable="values" :is="item.component"
                                                   v-bind="item.properties"></component>
                                    </div>
                                </div>
                            </form>
                            <component :is="formComponent" v-on:mounted="formViewLoad" ref="formView"></component>
                            <form id="componentForm">
                            </form>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-content :step="feeStep" v-if="feeStep>0">
                        <file-fee ref="fileFee"/>
                    </v-stepper-content>

                    <v-stepper-content :step="documentStep" v-if="documentStep>0">
                        <file-document ref="fileDocument"/>
                    </v-stepper-content>
                    <v-stepper-content :step="mailStep" v-if="mailStep>0">
                        <file-email ref="fileEmail"/>
                    </v-stepper-content>
                    <div style="text-align: right">
                        <v-btn color="primary" dark @click="onProcess" v-show="isEdit && taskId != null">
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <!--v-btn color="orange darken-2" dark @click="el=3" v-show="isEdit && taskId != null">
                            {{$t('lang.common.complete')}}
                        </v-btn-->
                        <v-btn color="error" dark @click="onCancel">
                            {{$t('lang.common.cancel')}}
                        </v-btn>
                    </div>
                </v-stepper-items>
            </v-stepper>
        </v-card>
    </v-dialog>
</template>

<script>
    import formStyle from "../../../../public/plugin/form/form.css"
    import CTextbox from "../../../components/form/Textbox";
    import Validator from "../../../../public/js/validator";
    import FormGenerator from "../../../../public/plugin/form/form";
    import axios from "axios/index";
    import VueController from "../../../../public/js/controller";
    import IDatepicker from "../../../components/form/DatePicker";
    import ISelectbox from "../../../components/form/SelectBox";
    import path from "../../../router/paths";
    import IDataTable from "../../../components/form/DataTable";
    import IEntityTable from "../../../components/form/EntityForm";
    import {message} from "@/shared/message";
    import IUpload from "../../../components/form/Upload";
    import ProcedureFee from "../procedure/ProcedureFee";
    import FileFee from "../../files/FileFee";
    import FileDocument from "../../files/FileDocument";
    import FileEmail from "../../files/FileEmail";

    export default {
        name: 'form-processing',
        components: {
            FileEmail,
            FileDocument,
            FileFee,
            ProcedureFee, IUpload, IEntityTable, IDataTable, ISelectbox, IDatepicker, CTextbox, Validator
        },
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'form'
            },
            fileId: {
                type: String | Number,
                default: null
            }
        },
        data: () => {
            return {
                values: {},
                show: false,
                isEdit: true,
                processDefinitionId: null,
                lstModel: [],
                taskId: null,
                task: null,
                formCode: null,
                executionId: null,
                processInstanceId: null,
                formProperties: {},
                formComponent: null,
                tabs: null,
                el: 1,
                formStep: 1,
                feeStep: 2,
                documentStep: 3,
                mailStep: 4
            }
        },
        watch: {
            values: {
                deep: true,
                handler() {
                    console.log("--- update values ---");
                    this.loadData(this.source, this.valueField, this.values);
                }
            },

            show: function (data) {
                if (data == false) {
                    this.values = {};
                    this.lstModel = {};
                    this.formProperties = {};
                }
            },
            el() {
                if (this.el == this.feeStep) {
                    this.$refs.fileFee.getFee(this.fileId, this.task);
                } else if (this.el == this.documentStep) {
                    this.$refs.fileDocument.getDocuments(this.fileId, this.task);
                } else if (this.el == this.mailStep) {
                    this.$refs.fileEmail.getEmail(this.fileId, this.task);
                }
            }
        },
        created() {
            axios.get("plugin/form/form.json").then(data => {
                FormGenerator.inputConfig = data;
            }, error => {
                console.log("Can't get form config");
            });
        },
        destroyed() {
        },
        methods: {
            getComponentByName: function (componentName) {
                //
                // get from paths
                //
                for (let i = 0; i < path.length; i++) {
                    if (componentName == path[i].name) {
                        return path[i].component;
                    }
                }
                //
                // get from registered component
                //
                return null;
            },

            formViewLoad: function () {
                this.$refs.formView.initFromFlow(this.values["executionId"]);
            },

            onStart: function () {
                axios.post(process.env.VUE_APP_API_URL + "/task/start?processId=" + this.processDefinitionId, this.values).then(
                    response => {
                        alert("Process success");
                        this.show = false;
                        let tl = VueController.getComponentByComponentName("task-management");
                        tl.search();
                    }, error => {
                        message.error("Process false: " + error);
                    }
                );
            },

            onComplete: function () {
                axios.post(process.env.VUE_APP_API_URL + "/task/complete?taskId=" + this.taskId, this.values).then(response => {
                    message.success("Process success");
                    this.show = false;
                }, error => {
                    message.error("Process false: " + error);
                });
            },

            nextStep() {
                this.el += 1;

            },

            onProcess() {
                if (this.el == this.formStep) {
                    this.onSave();
                    this.el = 2;
                } else if (this.el == this.feeStep) {
                    this.$refs.fileFee.onSave();
                    this.el = 3;
                } else if (this.el == this.documentStep) {
                    this.$refs.fileDocument.onSave();
                } else if (this.el == this.mailStep) {
                    this.$refs.fileEmail.onSave();
                }
            },


            onSave: function () {
                //this.runScript();
                if (this.taskId == null) {
                    this.onStart();
                } else {
                    //console.log(this.values);
                    axios.post(process.env.VUE_APP_API_URL + "/task/save?taskId=" + this.taskId, this.values).then(response => {
                        message.success("Process success");
                        this.show = false;
                    }, error => {
                        message.error("Process false: " + error);
                    });
                }

            },

            onShowForm: function (processDefinitionId, initData) {
                this.isEdit = true;
                this.processDefinitionId = processDefinitionId;
                this.taskId = null;
                if (initData != undefined && initData != null) {
                    this.values = initData;
                } else {
                    this.values = {};
                }
                //console.log(initData);
                let url = process.env.VUE_APP_API_URL + "/task/getStartFormKey?processDefinitionId=" + processDefinitionId;
                axios.post(url).then(
                    formCode => {
                        let formurl = process.env.VUE_APP_API_URL + "/form/getByCode?formCode=" + formCode;
                        this.initForm(formurl, false, null, this.onStart);
                    }
                )
            },

            showTaskData: function (formCode, executionId, taskId) {
                this.isEdit = true;
                this.taskId = taskId;
                //console.log(this.taskId);
                this.loadFormAndData(formCode, executionId);
            },

            viewTaskData: function (formCode, executionId, taskId) {
                this.isEdit = false;
                this.taskId = taskId;
                this.loadFormAndData(formCode, executionId);
            },

            initForm: function (url, loadVariable, executionId, method) {
                axios.post(url).then(
                    form => {
                        if (form == null || form == "") {
                            this.formStep = 0;
                            if (this.isEdit == false) {
                                message.error(this.$t("lang.task.noformToView"));
                                return;
                            }
                            method();
                        } else {
                            this.show = true;
                            //console.log(form.formConfig);
                            FormGenerator.loadFormModel(FormGenerator.decodeHTML(form.formConfig), "formProcess");
                            this.lstModel = FormGenerator.modelToInputProperties();
                            this.formComponent = null;
                            this.formProperties = FormGenerator.toFormProperties();
                            //console.log(this.formProperties);
                            if (this.formProperties.component == undefined || this.formProperties.component == "") {
                                if (this.formProperties["tabs"] != undefined && this.formProperties["tabs"] != null) {
                                    this.tabs = this.formProperties["tabs"][0].key;
                                }
                                this.formComponent = null;
                                for (let i = 0; i < this.lstModel.length; i++) {
                                    if (this.lstModel[i].properties["default"] != undefined && this.lstModel[i].properties["default"] != null) {
                                        this.values[this.lstModel[i].properties["name"]] = this.lstModel[i].properties["default"];
                                    }
                                }
                                for (let i = 0; i < this.lstModel.length; i++) {
                                    if (this.lstModel[i].type == "Component") {
                                        //console.log(this.lstModel[i].properties["componentName"]);
                                        this.lstModel[i].component = this.getComponentByName(this.lstModel[i].properties["componentName"]);
                                        try {
                                            //console.log(this.lstModel[i].properties["properties"]);
                                            if (this.lstModel[i].properties["properties"] != undefined && this.lstModel[i].properties["properties"] != null && this.lstModel[i].properties["properties"] != "") {
                                                let properties = JSON.parse(this.lstModel[i].properties["properties"]);
                                                for (let key in properties) {
                                                    this.lstModel[i].properties[key] = properties[key];
                                                }
                                            }
                                            //console.log(this.lstModel[i]);
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }
                                }
                                console.log(this.values);

                            } else {
                                this.lstModel = [];
                                try {
                                    let componentName = this.formProperties.component;
                                    for (let i = 0; i < path.length; i++) {
                                        if (componentName == path[i].name) {
                                            this.formComponent = path[i].component;
                                            break;
                                        }
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                            }

                            if (loadVariable) {
                                axios.post(process.env.VUE_APP_API_URL + "/task/taskWorkingVariables?taskId=" + executionId).then(
                                    data => {
                                        this.$set(this, "values", data);
                                        try {
                                            if (this.$refs.input != undefined && this.$refs.input != null && this.$refs.input.length > 0) {
                                                this.$refs.input[0].focus();
                                            }
                                        } catch (e) {
                                            //console.log(e);
                                        }
                                        //console.log(this.values);
                                    },
                                    error => {

                                    }
                                );
                            }
                        }
                    },
                    error => {

                    }
                );
            },

            loadFormAndData: function (formCode, executionId) {
                this.formCode = formCode;
                this.executionId = executionId;
                let url = process.env.VUE_APP_API_URL + "/form/getByCode?formCode=" + formCode;
                this.initForm(url, true, executionId, this.onComplete);
            },

            initStep(formKey, fileId, task) {
                if (formKey == undefined || formKey == null || formKey == "") {
                    this.formStep = 0;
                } else {
                    this.formStep = 1;
                }
                this.feeStep = this.formStep + 1;
                axios.post(process.env.VUE_APP_API_URL + "/files/payment/list?fileId=" + fileId + "&task=" + encodeURI(task)).then(data => {
                    if (data == null || data == "") {
                        this.feeStep = 0;
                    } else {
                        this.feeStep = 2;
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/files/document/list?fileId=" + fileId + "&task=" + encodeURI(task)).then(
                        data => {
                            if(data == null || data =="" || data.length == 0){
                                this.documentStep = 0;
                            } else {
                                this.documentStep = 3;
                                if(data[0].email_template == null || data[0].email_template == ""){
                                    this.mailStep = 0;
                                } else {
                                    this.mailStep = 4;
                                }
                            }
                            let count =0;
                            if(this.formStep >0){
                                count++;
                                this.formStep = count;
                            }
                            if(this.feeStep > 0){
                                count++;
                                this.feeStep = count;
                            }
                            if(this.documentStep >0){
                                count++;
                                this.documentStep = count;
                            }
                            if(this.mailStep >0){
                                count++;
                                this.mailStep = count;
                            }

                        },
                        error => {

                        }
                    )

                }, error => {
                });


            },

            loadWorkingTask(processInstanceId) {
                this.el = 1;
                this.show = true;
                this.processInstanceId = processInstanceId;
                axios.post(process.env.VUE_APP_API_URL + '/task/workingTask?processInstanceId=' + this.processInstanceId).then(data => {
                    for (let i = 0; i < data.length; i++) {
                        let task = data[i];
                        this.taskId = task.id;
                        this.task = task.name;
                        if (task.formKey != undefined && task.formKey != null && task.formKey != "") {
                            this.loadFormAndData(task.formKey, task.executionId);
                        } else {
                            this.formStep = 0;
                        }
                        break;
                    }
                }, error => {
                });
            },

            onCancel: function () {
                this.values = {};
                this.formProperties = {};
                this.lstModel = {};
                this.show = false;
            }
        }
    }
</script>
